export enum ContractTableRowKey {
  DATE = 'date',
  STATUS = 'status',
  PRODUCT = 'product',
  OWNER = 'owner',
  SUPPORT = 'support',
  INSUREDS = 'insureds',
  CONTRACT_IDENTIFIER = 'contractIdentifier',
  CLIENT_PRICE = 'clientPrice',
  UNREAD_NOTIFICATION_COUNT = 'unreadNotificationCount',
}
